import { ORDER_STATUS_LABELS_RU } from '@crm/shared'
import type { OrderStatus } from '@crm/shared'

/** Цвет бейджа статуса заказа (Tailwind-классы bg/text). */
export const ORDER_STATUS_STYLE: Record<OrderStatus, string> = {
  NEW: 'bg-gray-100 text-gray-700',
  PENDING_ROP: 'bg-amber-100 text-amber-800',
  CONFIRMED: 'bg-blue-100 text-blue-800',
  AWAITING_PAYMENT: 'bg-indigo-100 text-indigo-800',
  PARTIALLY_PAID: 'bg-cyan-100 text-cyan-800',
  PAID: 'bg-green-100 text-green-800',
  CLOSED: 'bg-emerald-100 text-emerald-800',
  CANCELLED: 'bg-red-100 text-red-700',
  ARCHIVED: 'bg-gray-200 text-gray-500',
}

export function orderStatusLabel(status: OrderStatus): string {
  return ORDER_STATUS_LABELS_RU[status]
}

export function round2(v: number): number {
  return Math.round(v * 100) / 100
}

/** Деньги без округления: копейки показываем, если они есть (1 123 123,34 ₽). */
export function formatMoney(value: number): string {
  return `${value.toLocaleString('ru-RU', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} ₽`
}

/**
 * Цена за единицу — полная, до 4 знаков (12,3456 ₽): решение 14.09.2026
 * «не округляем — полную цену надо». Суммы по-прежнему — formatMoney.
 */
export function formatPrice(value: number): string {
  return `${value.toLocaleString('ru-RU', { minimumFractionDigits: 0, maximumFractionDigits: 4 })} ₽`
}

export function formatDate(value: string | null): string {
  if (!value) return '—'
  return new Date(value).toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}

export function formatDateTime(value: string | null): string {
  if (!value) return '—'
  return new Date(value).toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
